// extracted by mini-css-extract-plugin
export const root = "link-list-module--root--3y3c6";